import { render, staticRenderFns } from "./MainImagesAddon.vue?vue&type=template&id=12513a2a&scoped=true"
import script from "./MainImagesAddon.vue?vue&type=script&lang=js"
export * from "./MainImagesAddon.vue?vue&type=script&lang=js"
import style0 from "./MainImagesAddon.vue?vue&type=style&index=0&id=12513a2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12513a2a",
  null
  
)

export default component.exports